import {analyticsLogEvent} from '../api'

interface EventWidgetParameters {
    eventName: 'custom_event'
    category: string
    action: string
    label?: string
}

/**
 * @name analyticsEventWidget
 *
 * @event
 *
 * @description
 * Tracks a custom event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomCategory} params.category - Category of the event.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel | undefined} [params.label] - Label of the event (optional).
 */
export function analyticsEventWidget({eventName, action, category, label}: EventWidgetParameters) {
    const eventDetails = {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
    }

    // Clean undefined values from the event details object
    Object.keys(eventDetails).forEach((key) => {
        if (eventDetails[key] === undefined) {
            delete eventDetails[key]
        }
    })

    analyticsLogEvent(eventName, eventDetails)
}
